import React from 'react';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { reverse } from 'named-urls';

import Grid from 'components/Grid';

import { useStore } from 'utils/hooks/store';

import routes from 'core/routes';

import { VatixError } from 'components/Error/types';

import { basicAuditTemplatesColumns } from './columns';

type AuditTemplatesTableProps = {
  onError: (error: VatixError | null) => void;
};

const AuditTemplatesTable: React.FunctionComponent<AuditTemplatesTableProps> = ({ onError }): React.ReactElement => {
  const { routing } = useStore();

  // Keeps the legacy `templateId` param name — rename deferred to M3.4.
  const onRowClick: GridEventListener<'rowClick'> = (item: GridRowParams): void => {
    routing.push(reverse(routes.dashboard.audits.templates.details, { templateId: item.id as string }));
  };

  return (
    <Grid
      basicColumns={basicAuditTemplatesColumns}
      entity="template"
      onError={onError}
      dataURL="/api/entities/audits/forms/"
      customNoRowsText="No templates have been created yet"
      onRowClick={onRowClick}
      onlyBasicExport
      sortBy={{ field: 'name', sort: 'asc' }}
    />
  );
};

export default AuditTemplatesTable;
